import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import shippingImg from "./assets/shipping.jpg";
import cargoImg from "./assets/freight.jpeg";
import warehouseImg from "./assets/trucking.jpg";

import {
  FaShip,
  FaBoxOpen,
  FaTruckMoving,
} from "react-icons/fa";

import "./DivisionPage.css";

const DivisionPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="division-section">
      <div className="division-container">

        {/* SHIPPING GOODS */}
        <div className="division-card" data-aos="fade-up" data-aos-delay="0">
          <img src={shippingImg} alt="Shipping Goods" className="division-img" />
          <FaShip className="division-icon" />
          <h3>International Shipping</h3>
          <p>
            We handle safe and fast international shipping of goods across countries,
            ensuring secure delivery and real-time tracking for all shipments.
          </p>
          <div className="division-footer">
            <span className="price">From $120 / shipment</span>
            <button className="inquire-btn">Make Inquiry</button>
          </div>
        </div>

        {/* CARGO / BARRED MATERIALS */}
        <div className="division-card" data-aos="fade-up" data-aos-delay="200">
          <img src={cargoImg} alt="Cargo Transport" className="division-img" />
          <FaBoxOpen className="division-icon" />
          <h3>Heavy Cargo & Materials</h3>
          <p>
            We specialize in transporting heavy and industrial materials including
            construction goods, machinery, and bulk cargo with safety assurance.
          </p>
          <div className="division-footer">
            <span className="price">From $300 / load</span>
            <button className="inquire-btn">Make Inquiry</button>
          </div>
        </div>

        {/* WAREHOUSING / LOGISTICS */}
        <div className="division-card" data-aos="fade-up" data-aos-delay="400">
          <img src={warehouseImg} alt="Warehousing" className="division-img" />
          <FaTruckMoving className="division-icon" />
          <h3>Warehousing & Logistics</h3>
          <p>
            Secure storage and distribution services for your goods with modern
            warehouse facilities and organized logistics support.
          </p>
          <div className="division-footer">
            <span className="price">From $80 / day</span>
            <button className="inquire-btn">Make Inquiry</button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default DivisionPage;